import { H2 } from "book/H2"

export const Article = () => {
	return (
		<>
			<p>! This is a draft !</p>

			<p>Getting up and running!</p>

			<p>TODO</p>
			<ul>
				<li>Normal installers</li>
				<li>Linux distros</li>
				<li>IDEs</li>
				<li>Build yourself</li>
				<li>Nightly builds (i.e. CI Artifacts)</li>
			</ul>

			<H2>Compiler</H2>

			<p>TODO</p>

			<H2>Tools</H2>

			<p>TODO</p>
		</>
	)
}
